/**
 * @generated SignedSource<<61369750ddf923ac90b0506811060b0b>>
 * @relayHash fe44a00964b99fcecacdeb15f62e7027
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 42ed423ccf9902ff08827492744e8d7fb2e74ec659a7ca0823a0d0882479e486

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type FavoriteCellMutation$variables = {
  entityId: string;
  isFavourite: boolean;
};
export type FavoriteCellMutation$data = {
  readonly jira: {
    readonly setEntityIsFavourite: {
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type FavoriteCellMutation = {
  response: FavoriteCellMutation$data;
  variables: FavoriteCellMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isFavourite"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "entityId",
                "variableName": "entityId"
              },
              {
                "kind": "Variable",
                "name": "isFavourite",
                "variableName": "isFavourite"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "JiraSetIsFavouritePayload",
        "kind": "LinkedField",
        "name": "setEntityIsFavourite",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "FavoriteCellMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FavoriteCellMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "42ed423ccf9902ff08827492744e8d7fb2e74ec659a7ca0823a0d0882479e486",
    "metadata": {},
    "name": "FavoriteCellMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0f0cd6ba3e47aa44d7513b70c6dc3ff3";

export default node;
